import Request from './request';
import store from "../store";

async function imageUpload(file, thumbnail, folder_type) {
  var data = new FormData();
  data.append("image", file);
  data.append("folder_type", folder_type ? folder_type : "materials");
  if (thumbnail) {
    data.append("thumbnail", "1");
    data.append("cropped_width", "180");
    data.append("cropped_height", "180");
  }
  return Request('post', "api/file/post-image", data);
}

async function imagesUpload(files, thumbnail, folder_type, notFullScreenLoading = false) {
  if (!notFullScreenLoading) {
    store.dispatch("fullscreenLoading");
  }
  if (Array.isArray(files)) {
    var data = new FormData();
    files.forEach(file => {
      data.append("images[]", file);
    })
    data.append("folder_type", folder_type ? folder_type : "materials");
    if (thumbnail) {
      data.append("thumbnail", "1");
      data.append("cropped_width", "180");
      data.append("cropped_height", "180");
    }
    if (!notFullScreenLoading) {
      store.dispatch("fullscreenLoadingStop");
    }
    return Request('post', "api/file/post-images", data);
  } else {
    if (!notFullScreenLoading) {
      store.dispatch("fullscreenLoadingStop");
    }
    return new Promise((resolve) => resolve());
  }
}

async function filesUpload(files, img_folder_type) {
  if (Array.isArray(files)) {
    var data = new FormData();
    files.forEach(file => {
      data.append("files[]", file);
    })
    data.append("img_folder_type", img_folder_type ? img_folder_type : "images");
    return Request('post', "api/file/post-files", data);
  } else {
    return new Promise((resolve) => resolve());
  }
}

async function imageQacenterUpload(file, thumbnail) {
  var data = new FormData();
  data.append("image", file);
  data.append("folder_type", "images");
  if (thumbnail) {
    data.append("thumbnail", "1");
    data.append("cropped_width", "180");
    data.append("cropped_height", "180");
  }
  return Request('post', "api/file/post-image", data);
}

async function fileUpload(file, folder_type) {
  var data = new FormData();
  data.append("file", file);
  data.append("folder_type", folder_type ? folder_type : "materials");
  return Request('post', "api/file/post-file", data);
}

export default {
  imageUpload,
  imagesUpload,
  imageQacenterUpload,
  fileUpload,
  filesUpload,
};